import { render, staticRenderFns } from "./TypeSaleOrderStatusForm.vue?vue&type=template&id=864c065c&"
import script from "./TypeSaleOrderStatusForm.vue?vue&type=script&lang=js&"
export * from "./TypeSaleOrderStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports